import { FlowStepOutputInstructions } from "./FlowStepOutputInstructions";
import { FlowStepData } from "../Steps/FlowStepData";

export class FlowExtraConnection {
    fromId: string;
    toId: string;
    fromStep: FlowStepData;
    fromInstruction: FlowStepOutputInstructions;

    constructor(fromId: string, toId: string, fromStep: FlowStepData, fromInstruction: FlowStepOutputInstructions) {
        this.fromId = fromId;
        this.toId = toId;
        this.fromStep = fromStep;
        this.fromInstruction = fromInstruction;
    }
}
